import React from 'react';
import {Button, Card, DatePicker, Form, message, Spin, Select, Input, Icon, Switch, Tooltip} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {patchEventConfig} from "../../services/evt";
import PurchaseServiceTips from "../PurchaseServiceTips";
import {isValidity} from "../../services/global";
import moment from 'moment';
import CkUploadFile from "../../components/CkUploadFile";

const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const loginedUser = state.loginedUser;
    const cmEnums = state.cmEnums;
    return {cmEnums,loginedUser};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewCheckinMusic extends React.Component {
    constructor(props) {
        super(props);
        this.pstView =null;
        console.log(props)
        this.state = {
            validity:false,
            formLoading: false,
            actionType:props.evt.config.actions ? props.evt.config.actions[0].action : null,
            actionExtras:{
                ROLL:[],
                SURVEY:[],
                VOTE:[],
                BARRAGE:[],
                LUCKYMONEY:[],
            }

        }
    }
    componentDidMount() {


        isValidity('SENIORMEMBER', (vaild) => {
            this.setState({
                validity:vaild
            })
        })

    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                console.log(values)
                patchEventConfig(Object.assign({id: this.props.evt.header.id}, values)).then(res => {
                    console.log("updateEventConfig res: ", res);
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    render() {
        const evt = this.props.evt;
        const {actionType} = this.state;

        const {getFieldDecorator, getFieldValue,getFieldsValue, getFieldError,setFieldsValue} = this.props.form;

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={()=>{
                this.state.validity ? this.intoEdit() : this.pstView.show()
            }}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{padding: "16px"}}>
                        {editableTools}

                        <CkInfoItem
                            label={<span>自定义签到成功音效&nbsp;

                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                上传后，可替换PC设备扫码签到成功时的音效
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>}
                        >
                            {
                                this.props.editable ?
                                    <div>
                                        {getFieldDecorator('checkinSuccessMusic', {
                                            initialValue:evt.config.checkinSuccessMusic,
                                            rules: [{required: false, message: '请上传音频文件',}],
                                            getValueFromEvent: (fileUrlObj) => {
                                                return fileUrlObj.url ? fileUrlObj.url : '';
                                            }
                                        })(
                                            <CkUploadFile
                                                accept='audio/*'
                                                customIcon={<Button><Icon type='upload'/>上传</Button>}
                                            />
                                        )}


                                    </div>
                                    :
                                    evt.config.checkinSuccessMusic ? evt.config.checkinSuccessMusic : "默认音乐"
                            }
                        </CkInfoItem>
                        <CkInfoItem
                            label={<span>自定义签到失败音效&nbsp;

                                        <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                 mouseEnterDelay={0.3} title={
                                            <div>
                                                上传后，可替换PC设备扫码签到失败时的音效
                                            </div>
                                        }>
                                                    <Icon type="question-circle-o"/>
                                            </Tooltip>
                                    </span>}
                        >
                            {
                                this.props.editable ?
                                    <div>
                                        {getFieldDecorator('checkinFailMusic', {
                                            initialValue:evt.config.checkinFailMusic,
                                            rules: [{required: false, message: '请上传音频文件',}],
                                            getValueFromEvent: (fileUrlObj) => {
                                                return fileUrlObj.url ? fileUrlObj.url : '';
                                            }
                                        })(
                                            <CkUploadFile
                                                accept='audio/*'
                                                customIcon={<Button><Icon type='upload'/>上传</Button>}
                                            />
                                        )}


                                    </div>
                                    :
                                    evt.config.checkinFailMusic ? evt.config.checkinFailMusic : "默认音乐"
                            }
                        </CkInfoItem>



                    </Card>
                </Spin>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}
                />
            </Form>
        )
    }
}


EvtViewCheckinMusic.contextTypes = {}

EvtViewCheckinMusic.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "checkinMusic",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinMusic.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinMusic));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinMusic.jsx